<!-- <header
  class="bcledger-header d-flex align-items-center justify-content-between has-border pb-2 mb-4">
  <h1>Total BC Ledger</h1>
  <div class="bcledger-panel d-flex justify-content-between ms-2 me-auto">
    <div class="lds-ring inline me-auto ms-2" *ngIf="false">
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
  <div class="user-panel col-auto d-flex justify-content-between">
    <div class="ms-3 nav-link p-0 dropdown d-flex align-items-center">
      <i class="icon-Export-excel me-2"></i>
      <a class="link" (click)="exportExcelFile()">Export excel</a>
    </div>
  </div>
</header> -->

<div class="col-lg-12 mb-3">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span class="d-flex justify-content-between align-items-center m-3 mb-2">
        <span class="col-auto">
          <h2 class="mb-0">Total BC Ledger</h2>
        </span>
        <span class="d-flex gap-2 customizefilter-btn">
          <p-button label=" Clear Filters" (click)="clearTable(dt)" />

          <p-button
            label="Export Excel"
            variant="outlined"
            icon="pi pi-cloud-upload"
            severity="secondary"
            (click)="exportExcelFile()"
            class="fullwdth secondary-btn" />
        </span>
      </span>

      <div class="col-12 p-3 pt-0">
        <p-table
          #dt
          stripedRows
          scrollHeight="calc(100vh - 310px)"
          responsiveLayout="scroll"
          [value]="totalBcLegderLists"
          [rows]="20"
          [rowHover]="true"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 20, 50, 1000]"
          [paginator]="totalBcLegderLists.length >= 20"
          [size]="'small'"
          [resizableColumns]="true"
          [paginator]="true"
          paginatorStyleClass="paginator-table-inside"
          styleClass="table-listing p-datatable-customers p-head-pad">
          <!-- <ng-template pTemplate="caption">
            <button
              type="button"
              class="btn btn btn-primary"
              (click)="clearTable(dt)">
              Clear Filters
            </button>
          </ng-template> -->
          <ng-template pTemplate="header">
            <tr class="table-head">
              <th pSortableColumn="Description">
                Description <p-sortIcon field="Description"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="Description"
                  display="menu"></p-columnFilter>
              </th>
              <th pSortableColumn="PRCharges">
                PR & Charges <p-sortIcon field="PRCharges"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="PRCharges"
                  display="menu"></p-columnFilter>
              </th>
              <th pSortableColumn="Volume">
                Volume <p-sortIcon field="Volume"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="Volume"
                  display="menu"></p-columnFilter>
              </th>
              <th pSortableColumn="TotalCommission">
                Total Commission
                <p-sortIcon field="TotalCommission"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="TotalCommission"
                  display="menu"></p-columnFilter>
              </th>
              <th pSortableColumn="Reserve">
                Reserve <p-sortIcon field="Reserve"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="Reserve"
                  display="menu"></p-columnFilter>
              </th>
              <th pSortableColumn="NetCommission">
                Net Commission <p-sortIcon field="NetCommission"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="NetCommission"
                  display="menu"></p-columnFilter>
              </th>
              <th pSortableColumn="NetBCCommissionDue">
                Net BC Commission Due
                <p-sortIcon field="NetBCCommissionDue"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="NetBCCommissionDue"
                  display="menu"></p-columnFilter>
              </th>
              <th pSortableColumn="AccruedReserve">
                Accured Reserve <p-sortIcon field="AccruedReserve"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="AccruedReserve"
                  display="menu"></p-columnFilter>
              </th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-totalBcLegderList
            let-rowIndex="rowIndex">
            <tr
              class="p-selectable-row"
              [pSelectableRow]="totalBcLegderList"
              [pSelectableRowIndex]="rowIndex"
              [ngClass]="{
                'green-background': isBackground(totalBcLegderList.Description),
              }">
              <td>
                <a
                  (click)="onDescriptionClick(totalBcLegderList.Description)"
                  class="has-link"
                  >{{ totalBcLegderList.Description }}</a
                >
              </td>
              <td class="align-right">
                {{ totalBcLegderList.PRCharges | number: "1.2-2" }}
              </td>
              <td class="align-right">
                {{ totalBcLegderList.Volume | number: "1.2-2" }}
              </td>
              <td class="align-right">
                {{ totalBcLegderList.TotalCommission | number: "1.2-2" }}
              </td>
              <td class="align-right">
                {{ totalBcLegderList.Reserve | number: "1.2-2" }}
              </td>
              <td class="align-right">
                {{ totalBcLegderList.NetCommission | number: "1.2-2" }}
              </td>
              <td class="align-right">
                {{ totalBcLegderList.NetBCCommissionDue | number: "1.2-2" }}
              </td>
              <td class="align-right">
                {{ totalBcLegderList.AccruedReserve | number: "1.2-2" }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="20">No bc ledger found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-card>
  </div>
</div>

<jni-modal-stacker
  *ngIf="displayModal"
  [displayModal]="displayModal"
  (closeEvent)="closeBcLedgerModal()">
  <div class="panelBody">
    <jni-misc
      *ngIf="bcLedgerStacker.Path === 'Misc'"
      [bcLedgerStacker]="bcLedgerStacker"
      (closeModalEvent)="closeBcLedgerModal()">
    </jni-misc>
    <jni-sample
      *ngIf="bcLedgerStacker.Path === 'Samples'"
      [bcLedgerStacker]="bcLedgerStacker"
      (closeModalEvent)="closeBcLedgerModal()">
    </jni-sample>
    <jni-backlog-details
      *ngIf="bcLedgerStacker.Path === 'backlogdetails'"
      [bcLedgerStacker]="bcLedgerStacker"
      (closeModalEvent)="closeBcLedgerModal()">
    </jni-backlog-details>
    <jni-gp-adjustment
      *ngIf="bcLedgerStacker.Path === 'GPAdjustments'"
      [bcLedgerStacker]="bcLedgerStacker"
      (closeModalEvent)="closeBcLedgerModal()">
    </jni-gp-adjustment>
    <jni-freight
      *ngIf="bcLedgerStacker.Path === 'Freight'"
      [bcLedgerStacker]="bcLedgerStacker"
      (closeModalEvent)="closeBcLedgerModal()">
    </jni-freight>
    <jni-sales-commission
      *ngIf="bcLedgerStacker.Path === 'SalesCommissions'"
      [bcLedgerStacker]="bcLedgerStacker"
      (closeModalEvent)="closeBcLedgerModal()">
    </jni-sales-commission>
    <jni-adjustments
      *ngIf="bcLedgerStacker.Path === 'Adjustments'"
      [bcLedgerStacker]="bcLedgerStacker"
      (closeModalEvent)="closeBcLedgerModal()">
    </jni-adjustments>
    <jni-nets-charged
      *ngIf="bcLedgerStacker.Path === 'NetsChargedorCredited'"
      [bcLedgerStacker]="bcLedgerStacker"
      (closeModalEvent)="closeBcLedgerModal()">
    </jni-nets-charged>
    <jni-charge-back
      *ngIf="bcLedgerStacker.Path === 'Chargebacks'"
      [bcLedgerStacker]="bcLedgerStacker"
      (closeModalEvent)="closeBcLedgerModal()">
    </jni-charge-back>
    <jni-ytdgp
      *ngIf="bcLedgerStacker.Path === 'YTDGP'"
      [bcLedgerStacker]="bcLedgerStacker"
      (closeModalEvent)="closeBcLedgerModal()">
    </jni-ytdgp>
    <jni-total-ap-misc
      *ngIf="bcLedgerStacker.Path === 'TotalAPMisc'"
      [bcLedgerStacker]="bcLedgerStacker"
      (closeModalEvent)="closeBcLedgerModal()">
    </jni-total-ap-misc>
    <jni-commissions-paid-total
      *ngIf="bcLedgerStacker.Path === 'CommissionsPaidTotal'"
      [bcLedgerStacker]="bcLedgerStacker"
      (closeModalEvent)="closeBcLedgerModal()">
    </jni-commissions-paid-total>
    <jni-total-sales-commissions-adjustments
      *ngIf="bcLedgerStacker.Path === 'TotalSalesCommissionsAdjustments'"
      [bcLedgerStacker]="bcLedgerStacker"
      (closeModalEvent)="closeBcLedgerModal()">
    </jni-total-sales-commissions-adjustments>
  </div>
</jni-modal-stacker>
